module.exports = __webpack_public_path__ + "static/media/hacker.26023fde.svg";